/**
 * Ограничитель количества показываемых элементов:
	- скрывает строки, выходящие за пределы диапазона limit,
	- показывает скрытые строки при клике на элемент(ы), описанные селектором trigger.
 */
class ShowMore {

  /**
   * 
   * @param {Object} options 
   * @param {String} options.selector Селектор элементов (строк), показ которых требуется ограничить
   * @param {Number} options.limit Количество показываемых элементов (строк)
   * @param {String} options.trigger Селектор элемента, отвечающего за показ скрытых элементов (строк)
   */
  constructor(options) {
    this.items = Array.prototype.slice.call(document.querySelectorAll(options.selector), 0);
    this.trigger = document.querySelector(options.trigger);
    this.limit = options.limit;
    // заканчиваем работу, если элементы отсутствуют
    if (this.items.length > 0) {
      // вычисляем значение display на основе первого элемента
      this.display = window.getComputedStyle(this.items[0], null).display;
      this._init();
    }
  }

  _init() {
    // скрываем trigger, если отсутствуют скрытые строки
    if (this.items.length <= this.limit) {
      this.hide(this.trigger);
      return;
    }

    // скрываем строки, выходящие за пределы диапазона
    const hiddenItems = this.items
      .filter((item, index) => index >= this.limit, this);

    hiddenItems.forEach((item) => this.hide(item));

    // показываем скрытые строки при клике на trigger
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      hiddenItems.forEach((item) => this.show(item));
      this.hide(this.trigger);
    });
  }

  /**
   * Hides element
   * @param {HTMLElement} item Element to hide
   */
  hide(item) {
    item.style.display = 'none';
  }

  /**
   * Shows element
   * @param {HTMLElement} item Element to show
   */
  show(item) {
    item.style.display = this.display;
  }
}

export default ShowMore;